<ng-template #eulaAgreement let-modal>
	<div class="modal-content">
    <div class="modal-header d-block">
			<div class="bg-warning-subtle position-relative">
				<div class="card-body p-5">
					<div class="text-center">
						<h3 class="fw-semibold">Term & Conditions</h3>
						<p class="mb-0 text-muted">Last update: 01 Jan, 2024</p>
					</div>
				</div>
				<div class="shape">
					<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="1440" height="60" preserveAspectRatio="none" viewBox="0 0 1440 60">
						<g fill="none">
							<path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z" style="fill: var(--vz-secondary-bg);"></path>
						</g>
						<defs>
							<mask id="SvgjsMask1001">
								<rect width="1440" height="60" fill="#ffffff"></rect>
							</mask>
						</defs>
					</svg>
				</div>
			</div>
		</div>
    <div class="modal-body">
			<div class="text-end mb-2">
				<button type="button" (click)="zoomDown()" class="me-2 btn rounded-pill btn-secondary waves-effect waves-light">-</button>
				<button type="button" (click)="zoomUp()" class="btn rounded-pill btn-secondary waves-effect waves-light">+</button>
			</div>
			<pdf-viewer
				[src]="eulaPDF"
				[render-text]="false"
				[show-all]="true"
				[original-size]="false"
				[autoresize]="true"
				[zoom]="zoom"
				[zoom-scale]="'page-width'"
				>
			</pdf-viewer>
		</div>
		<div class="modal-footer">
			<div>
				<button (click)="modal.dismiss('Close click')" class="btn btn-primary btn-load">Close</button>
			</div>
		</div>
	</div>
</ng-template>

